import * as React from "react";

import { Button } from "../../../src/components/ui/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
} from "../../../src/components/ui/card";
import { useNavigate } from "react-router-dom";

export function CookiesMessage() {
  const [cardHidden, setCardHidden] = React.useState(false);
  const nav = useNavigate();
  const cookiesMessage = localStorage.getItem(
    "cookiesDecision"
  );
  React.useEffect(() => {
    if (cookiesMessage === "accepted") {
      setCardHidden(true);
    }
  }, [cookiesMessage]);
  return cookiesMessage !== "accepted" ? (
    <Card
      className={`fixed z-50 bottom-0 left-0 w-screen rounded-none transition-transform duration-500 ease-in-out ${
        !cardHidden
          ? "transform translate-y-0"
          : "transform translate-y-full"
      }`}
    >
      <CardHeader>
        <CardDescription>
          We use cookies to enhance your browsing
          experience, analyze site traffic, and serve
          personalized content. By continuing to browse our
          site, you consent to our use of cookies. For more
          information, please refer to our Privacy Policies.
        </CardDescription>
      </CardHeader>
      <CardFooter className="flex justify-between">
        <Button
          className="rounded-none"
          onClick={() => {
            localStorage.setItem(
              "cookiesDecision",
              "accepted"
            );
            setCardHidden(true);
          }}
        >
          Accept Cookies
        </Button>
        <Button
          variant="link"
          onClick={() => nav("/privacy-policies")}
        >
          Learn More
        </Button>
      </CardFooter>
    </Card>
  ) : (
    <></>
  );
}
